import {
    array,
    boolean,
    nativeEnum,
    number,
    object,
    string,
    TypeOf,
} from 'zod';

import { ModelImage } from '../common';
import { ProductExtend } from './extend';
import { ProductPerson } from './people';
import { ProductType } from './types';

/* ------------------------------- LegacyImage ------------------------------ */

export const LegacyImages = object({
    thumbnail: string().optional(),
    hero: string().optional(),
    poster: string().optional(),
});
export type LegacyImages = TypeOf<typeof LegacyImages>;

/* ------------------------------- ProductSEO ------------------------------- */

export const OpenGraph = object({
    title: string().optional(),
    description: string().optional(),
});

export type OpenGraph = TypeOf<typeof OpenGraph>;

export const ProductSEO = object({
    hide: boolean().optional(),
    title: string().optional(),
    description: string().optional(),
    openGraph: OpenGraph.optional(),
});

export type ProductSEO = TypeOf<typeof ProductSEO>;

/* ------------------------------- BaseProduct ------------------------------ */

export const BaseProduct = object({
    ageRating: string().optional(),
    categories: array(string()),
    description: string().default(''),
    duration: string().optional(),
    extend: ProductExtend.optional(),
    feature: string().optional(),
    id: string(),
    image: ModelImage.optional(),
    images: LegacyImages,
    links: object({ image: string().optional() }),
    name: string(),
    parentalAdvisory: string().default(''),
    persons: array(ProductPerson),
    published: string().optional(),
    reference: string(),
    released: string().default(''),
    seo: ProductSEO.optional(),
    shortDescription: string().default(''),
    trailer: string().optional(),
    type: nativeEnum(ProductType),

    /* START Not Currently in the API */
    progress: number().optional(),
    /* END */
});
export type BaseProduct = TypeOf<typeof BaseProduct>;
